import React from 'react';
import ReactGA from 'react-ga';
import SignUpForm from './SignUpForm';

function SignUp(props) {
  ReactGA.set({ page: window.location.pathname }); // Update the user's current page
  ReactGA.pageview(window.location.pathname); // Record a pageview for the given page
    
  return (
    <div className="sign-up">
      <div className="main-image">

          <div className="row justify-content-end">
              <div className="col-7 col-md-6 col-lg-12 mt-3 mr-5 text-right">
                <h1 className="title blue-font">15 Senior Nutrition<br/> Myths Debunked</h1>

                <h4 className="sub-title red-font">Download free of charge</h4>
              </div>
          </div>
          <div className="row justify-content-end">
                  <div className="col-sm-7 col-md-6 col-lg-5 mr-3 d-none d-sm-block">
                      <SignUpForm user={props.user} nameValid={props.nameValid} emailValid={props.emailValid} postalCodeValid={props.postalCodeValid} formErrors={props.formErrors} tryToSignUp={props.tryToSignUp} updateUser={props.updateUser} />
              </div>
          </div>
      </div>

      <div className="row">
        <div className="col-12 col-sm-7 col-md-6 col-lg-7">


          <span className="d-block d-sm-none">
                      <SignUpForm user={props.user} tryToSignUp={props.tryToSignUp} nameValid={props.nameValid} emailValid={props.emailValid} postalCodeValid={props.postalCodeValid} formErrors={props.formErrors}  updateUser={props.updateUser} />
          </span>

          <div className="row p-4">
            <h3 className="blue-font col-12 bold">
              Feeling overwhelmed by contradictory facts about senior nutrition and ever-changing diet fads?
            </h3>

            <h3 className="red-font col-12 bold">
              We’re busting myths about nutritional requirements for seniors
            </h3>

            <p className="read-our-ebook description col-12">
              Read our eBook to discover the truth behind these common myths:
            </p>

        <table className="col-12 description">
            <tbody>
              <tr>
                <td className="align-top pt-2">
                                      <img className="list-icon" src="./img/salt_shaker.png" alt="salt shaker" />
                </td>
                <td className="pr-5 pb-2">
                    All seniors require a low sodium diet?
                </td>
              </tr>

              <tr>
                <td className="align-top pt-2">
                                      <img className="list-icon" src="./img/meat.png" alt="meat" />
                </td>
                <td className="pr-5 pb-2">
                    Seniors don’t need as much protein as when they were younger?
                </td>
              </tr>

              <tr>
                <td className="align-top pt-2">
                                      <img className="list-icon" src="./img/gluten.png" alt="gluten" />
                </td>
                <td className="pr-5 pb-2">
                    A gluten-free diet is healthy for all seniors?
                </td>
              </tr>

              <tr>
                <td>

                </td>
                <td className="pr-5 pb-2">
                    And more…
                </td>
                </tr>
            </tbody>
            </table>
          </div>
        </div>

        <div className="col-12 col-sm-5 col-md-6 col-lg-5">
          <div className="row">
            <div className="quote mb-2">
              <h3 className="text-center blue-font">
                &quot;My goal with this guide is to provide much-needed clarity surrounding the nutritional needs of seniors&quot;
              </h3>
              <h5 className="text-center">
                Andrea Olynyk, Consultant, Registered Dietitian
              </h5>
            </div>

                      <img alt="Andrea Olynyk, Consultant, Registered Dietitian" className="dr-image col-10 col-sm-12 col-md-8 col-lg-6 m-auto p-0 pl-5 pr-5" src="./img/dr_website_full.png" />
          </div>
        </div>
      </div>

    </div>
  )
}

export default SignUp;
